import { zonedTimeToUtc } from "date-fns-tz";
import { useEffect, useState } from "react";
import {
  StyledContactInfoContainer,
  StyledContactInfoContent,
  StyledLinkButton,
} from "../styles";
import { UserBirthdayForm } from "./form";
import {
  StyledCheckoutComponent,
  StyledHeaderText,
  StyledStepContent,
  StyledStepHeader,
} from "@/components/checkout/uielements";
import StringAccessor from "@/components/cmsConfig/stringAccessor";
import { DATE_FORMAT } from "@/constants/dates";
import { useSelector } from "@/redux";
import { formatDate, getClientOffset } from "@/utils/dates";

export const UserBirthday = () => {
  const [displayBirthdayForm, setDisplayBirthdayForm] = useState(false);
  const [birthdayDisabled, setBirthdayDisabled] = useState(false);
  const me = useSelector((root) => root.app.me.data);
  const birthdayWebConfig = useSelector(
    (root) => root.app.cmsConfig.webConfig.accounts.birthday
  );
  const cancelEdit = () => {
    setDisplayBirthdayForm(false);
  };

  useEffect(() => {
    setBirthdayDisabled(birthdayWebConfig === "disabled");
  }, [birthdayWebConfig]);

  if (birthdayDisabled) {
    return null;
  }

  return (
    <StyledCheckoutComponent>
      <StyledStepHeader enabled={true}>
        <StringAccessor
          accessor="account.birthday_header"
          tag={StyledHeaderText}
        />
      </StyledStepHeader>

      {/* Birthday read-only state */}
      {me?.birthday && (
        <StyledContactInfoContainer>
          <StyledContactInfoContent>
            <div>
              <p>
                {/* Example: "1990-08-01" - stored date. We would like to convert it to MM/DD/YYYY format
                  current implementation is aimed to do that => "08/01/1990"
                  instead of using straight formatDate(storedDate, "MM/DD/YYYY") => "07/31/1990" - considers */}
                {formatDate(
                  zonedTimeToUtc(me.birthday, getClientOffset()),
                  DATE_FORMAT.MONTH_DAY_YEAR
                )}
              </p>
            </div>
          </StyledContactInfoContent>
        </StyledContactInfoContainer>
      )}

      {/* 'Add your birthday' CTA */}
      {!me?.birthday && !displayBirthdayForm && (
        <StyledLinkButton
          onClick={() => setDisplayBirthdayForm(true)}
          bold={true}
        >
          <StyledContactInfoContainer>
            <StringAccessor accessor="account.birthday_instructions" />
          </StyledContactInfoContainer>
        </StyledLinkButton>
      )}

      {/* Birthday form */}
      {!me?.birthday && displayBirthdayForm && (
        <StyledStepContent
          enabled={true}
          data-testid="birthday-form-step-content"
        >
          <UserBirthdayForm onCancel={cancelEdit} />
        </StyledStepContent>
      )}
    </StyledCheckoutComponent>
  );
};
